<template>
    <v-row justify="center">
    <v-dialog v-model="dialogLocal" width="900">
      <v-card>
        <v-form ref="es" action="#" lazy-validation>
        <v-card-title class="justify-space-between" :style="{'background-color': topbarcolor}" style="color: white; padding-top: 5px; padding-bottom: 5px">
          <span class="headline">Sold Value Pass: {{modalInfo.ValuePassName}}</span>
          <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="white">fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-data-table
                        calculate-widths
                        :headers="headers"
                        :items="items"
                        hide-default-footer
                        :loading="tableloading"
                        loading-text= "Loading Data... Please wait"
                        :items-per-page="100"
                        id="main-table"
                        dense
                    >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{page > 1 ? (page - 1) * 100 + props.index + 1 : props.index + 1}}</td>
                            <td>{{props.item.loginMobileID}}</td>
                            <td>{{props.item.name}}</td>
                            <td>{{props.item.mobile}}</td>
                            <td>{{props.item.email}}</td>
                            <td>{{props.item.ValuePassQuantity}}</td>
                            <td>{{props.item.TotalUnitByVPProductIDSubscriberGrandTotal}}</td>
                            <td>{{props.item.TotalUnitUsedByVPProductIDSubscriber}}</td>
                            <td>{{props.item.TotalUnitUnusedByVPProductIDSubscriber}}</td>
                            <!-- <td>{{props.item.DateUpdated}}</td> -->
                        </tr>
                    </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    </v-row>
</template>

<script>
import * as moment from "moment";
import * as tz from "moment-timezone";

  export default {
    props: ['dialog', 'modalInfo', 'customText', 'system', 'master'],

    data() {
        return {
            dialogLocal: false,
            items: [],
            headers: [
                { text: '#', value: 'row' },
                { text: 'Mobile ID', value: 'loginMobileID' },
                { text: 'Name', value: 'name' },
                { text: 'Mobile No.', value: 'mobile' },
                { text: 'Email', value: 'email' },
                { text: 'Quantity', value: 'ValuePassQuantity' },
                { text: 'Total Amount (RM)', value: 'TotalUnitByVPProductIDSubscriberGrandTotal'},
                { text: 'Used', value: 'TotalUnitUsedByVPProductIDSubscriber' },
                { text: 'Unused', value: 'TotalUnitUnusedByVPProductIDSubscriber' },
                // { text: 'Updated Date', value: 'DateUpdated' },
            ],
            tableloading: false,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            page: 1,
            topbarcolor: JSON.parse(localStorage.getItem('theme')).topbarcolor
        }
    },

    watch: {
        dialog: {
        handler: function(value) {
            this.modalHandler();
            if(value == true){
                this.handleValue();
            }
        },
        },

        dialogLocal: {
        handler: function(value) {
            this.modalCloseHandler();
        },
        },
    },

    methods: {
        async list(){
            this.items = [];
            let req = {
                "ValuePassProductID": this.modalInfo.ValuePassProductID,
            }

            this.tableloading = true;
            let response = await this.$store.dispatch('getValuePassOwnershipUnitsListByVPProductID', req)
            if (response){
                let dt = response.data.record;

                for(var i=0; i<dt.length; i++){
                    dt[i].row = this.page > 1 ? (this.page - 1) * 100 + i + 1 : i + 1;
                    dt[i].TotalUnitByVPProductIDSubscriberGrandTotal = dt[i].TotalUnitByVPProductIDSubscriberGrandTotal.toFixed(2);
                    dt[i].DateUpdated = dt[i].DateUpdated == null ? 'N/A' : moment(dt[i].DateUpdated).format('DD-MM-YYYY hh:mm:ss A');
                }

                this.items = dt;
                this.tableloading = false;
            }
        },

        modalHandler(){
            this.dialogLocal = !this.dialogLocal;
        },

        modalCloseHandler(){
            if (this.dialogLocal == false){
                this.$emit('closed', false);
            }
        },

        handleValue(){
            this.list();
            /*
            this.items.parkerID = this.modalInfo.parkerID;
            this.items.name = this.modalInfo.name;
            this.items.mobile = this.modalInfo.mobile;
            this.items.email = this.modalInfo.email;
            */
        },
    }
  }
</script>